// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2LN8B","cell":"ColumnAccessor_cell__3Q7tM","firstCellAccent":"ColumnAccessor_firstCellAccent__3j4kl"};